var map = {
	"./asm/translation.json": 4637,
	"./bn/translation.json": 4827,
	"./en/translation.json": 1996,
	"./gu/translation.json": 5853,
	"./hi/translation.json": 5305,
	"./kn/translation.json": 1961,
	"./ml/translation.json": 4099,
	"./mr/translation.json": 8478,
	"./or/translation.json": 246,
	"./pa/translation.json": 5023,
	"./ta/translation.json": 4227,
	"./te/translation.json": 3819,
	"./ur/translation.json": 6088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3852;